/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Word_To_Next_EventInputs */

const en_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Word To Next Event`)
};

const fr_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer un mot vers l'evenement suivant`)
};

const de_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wort zum nächsten Ereignis verschieben`)
};

const it_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la parola all'evento successivo`)
};

const ru_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перенести слово на следующее мероприятие`)
};

const es_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover palabra al siguiente evento`)
};

const zh_cn2_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将单词移至下一个事件`)
};

const ja_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を次のイベントに移動`)
};

const hi_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द को अगले कार्यक्रम में ले जाएं`)
};

const pt_pt2_shortcut_keys_name_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover palavra para o próximo evento`)
};

/**
* | output |
* | --- |
* | "Move Word To Next Event" |
*
* @param {Shortcut_Keys_Name_Move_Word_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_word_to_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Word_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_move_word_to_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_move_word_to_next_event(inputs)
	return en_shortcut_keys_name_move_word_to_next_event(inputs)
});